import { redirect } from 'LoginUI/js/lib/redirect';
export const redirectToSanitizedHubSpotUrl = (url, {
  decode = true
} = {}) => {
  const currentURL = new URL(window.location.href);
  const parsedUrl = new URL(decode ? decodeURIComponent(url) : url);
  if (parsedUrl.origin !== currentURL.origin) {
    return;
  }
  parsedUrl.protocol = 'https';
  redirect(parsedUrl.toString());
};